import { render, staticRenderFns } from "./AssetsList.vue?vue&type=template&id=dcf30440&scoped=true&"
import script from "./AssetsList.vue?vue&type=script&lang=js&"
export * from "./AssetsList.vue?vue&type=script&lang=js&"
import style0 from "./AssetsList.vue?vue&type=style&index=0&id=dcf30440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf30440",
  null
  
)

export default component.exports